import { render, staticRenderFns } from "./SingleParamPeakDemand.vue?vue&type=template&id=21330981&scoped=true"
import script from "./SingleParamPeakDemand.vue?vue&type=script&lang=js"
export * from "./SingleParamPeakDemand.vue?vue&type=script&lang=js"
import style0 from "./SingleParamPeakDemand.vue?vue&type=style&index=0&id=21330981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21330981",
  null
  
)

export default component.exports